import script from "./UserPersonalInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPersonalInfos.vue?vue&type=script&setup=true&lang=js"

import "./UserPersonalInfos.vue?vue&type=style&index=0&id=f0e078f2&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e078f2"]])

export default __exports__